import { resolveApiBaseUrl } from '../../../../shared/api/baseUrl';

/**
 * Gift Vouchers API Configuration
 * Thin wrapper around the shared resolver with Vite env vars.
 */
export function getApiBaseUrl(): string {
  return resolveApiBaseUrl({
    explicitUrl: import.meta.env.VITE_API_BASE_URL as string | undefined,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    isDev: !!import.meta.env.DEV,
    useEmulator: import.meta.env.VITE_USE_EMULATOR === 'true',
  });
}
